/**
 * Legacy deploy route — redirects to unified provision workspace.
 */

import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useLanguage } from '@/state/language/LanguageProvider';

const AIStudioDeployInstancePage: React.FC = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const agentId = searchParams.get('agentId');
    const query = agentId ? `?agentId=${encodeURIComponent(agentId)}` : '';
    navigate(`/ai-studio/instances/provision${query}`, { replace: true });
  }, [navigate, searchParams]);

  return (
    <main className="px-4 py-4 md:px-6 lg:px-8">
      <p className="text-base text-[var(--color-surface-text-secondary)]">
        {t('aiStudio.instances.loading')}
      </p>
    </main>
  );
};

export default AIStudioDeployInstancePage;
